import React, { Component, Fragment } from 'react';
import { Button, Form, Loader, Segment } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { fetchLanguages } from '../../Lookups/util';
import axios from 'axios';
import { toast } from 'react-toastify';

class NonCycleProgramForm extends Component {
    constructor(props) {
        super(props);

        const program = props.program || {};
        const enTranslation = program.translations
            ? program.translations.find(t => t.language === 'en') || {}
            : {};

        this.state = {
            program: {
                ...program,
                programLeadId: program.programLead ? program.programLead.id : null,
            },
            programNameEn: enTranslation.programName || '',
            mainFieldOfStudyEn: enTranslation.mainFieldOfStudy || '',
            programStructureEn: enTranslation.programStructure || '',
            accessRequirementsEn: enTranslation.accessRequirements || '',
            learningOutcomesEn: enTranslation.learningOutcomes || '',
            professionalStatusEn: enTranslation.professionalStatus || '',
            additionalInformationEn: enTranslation.additionalInformation || '',
            sourcesOfAdditionalInformationEn: enTranslation.sourcesOfAdditionalInformation || '',

            toggleCertificateSupplementInfo: !!(program.hasCertificateSupplement),
            saving: false,
            loadingOptions: true,
            errors: {},

            nonCycleStudyProgramTypeOptions: [],
            programLeadOptions: [],
            attendanceTypeOptions: [],
            languageOptions: [],
        };
    }

    componentDidMount() {
        Promise.all([
            axios.get('/non-cycle-study-program-types'),
            axios.post('/employees/by-key/professor', {}),
            axios.get('/attendance-types'),
            fetchLanguages(),
        ])
            .then(([types, employees, attendanceTypes, languages]) => {
                this.setState({
                    nonCycleStudyProgramTypeOptions: types.data.map(t => ({
                        key: t.id,
                        value: t,
                        text: t.name,
                    })),
                    programLeadOptions: employees.data.map(e => ({
                        key: e.organizationalUnitEmployeeId,
                        value: e.organizationalUnitEmployeeId,
                        text: `${e.firstName} ${e.lastName}`,
                    })),
                    attendanceTypeOptions: attendanceTypes.data.map(a => ({
                        key: a.id,
                        value: a,
                        text: a.name,
                    })),
                    languageOptions: languages.data.map(l => ({
                        key: l.id,
                        value: l,
                        text: l.name,
                    })),
                    loadingOptions: false,
                });
            });
    }

    onChangeProgram = (updatedFields) => {
        this.setState(prevState => ({
            program: { ...prevState.program, ...updatedFields },
        }));
    };

    handleSubmit = () => {
        const isEditing = !!this.props.program;
        const { program } = this.state;

        const errors = {
            nonCycleStudyProgramTypeErr: !program.nonCycleStudyProgramType,
            programNameErr: !program.programName,
        };

        if (Object.values(errors)
            .some(e => e)) {
            this.setState({
                errors,
                saving: false
            });
            toast(<FormattedMessage id="externalStudent.toast.fillRequiredFields"/>);
            return;
        }

        this.setState({ saving: true }, () => {
            const body = {
                id: program.id || null,
                nonCycleStudyProgramTypeId: program.nonCycleStudyProgramType ? program.nonCycleStudyProgramType.id : null,
                programLeadId: program.programLeadId || null,
                maxEcts: program.maxEcts || null,
                programName: program.programName || null,
                comment: program.comment || null,
                attendanceTypeId: program.attendanceType ? program.attendanceType.id : null,
                languageIds: program.languages ? program.languages.map(l => l.id) : [],
                programDurationMonths: program.programDurationMonths || null,
                dateFrom: program.dateFrom || null,
                dateTo: program.dateTo || null,
                hasCertificateSupplement: this.state.toggleCertificateSupplementInfo,
                mainFieldOfStudy: program.mainFieldOfStudy || null,
                programStructure: program.programStructure || null,
                accessRequirements: program.accessRequirements || null,
                learningOutcomes: program.learningOutcomes || null,
                professionalStatus: program.professionalStatus || null,
                additionalInformation: program.additionalInformation || null,
                sourcesOfAdditionalInformation: program.sourcesOfAdditionalInformation || null,
                translations: [{
                    language: { twoLetterCode: 'en' },
                    programName: this.state.programNameEn || null,
                    mainFieldOfStudy: this.state.mainFieldOfStudyEn || null,
                    programStructure: this.state.programStructureEn || null,
                    accessRequirements: this.state.accessRequirementsEn || null,
                    learningOutcomes: this.state.learningOutcomesEn || null,
                    professionalStatus: this.state.professionalStatusEn || null,
                    additionalInformation: this.state.additionalInformationEn || null,
                    sourcesOfAdditionalInformation: this.state.sourcesOfAdditionalInformationEn || null,
                }],
            };

            const apiCall = isEditing
                ? axios.put('/non-cycle-programs/', body)
                : axios.post('/non-cycle-programs/', body);

            apiCall
                .then(() => {
                    this.setState({ saving: false });
                    this.props.onCloseForm();
                    this.props.onRefreshData();
                    toast(<FormattedMessage id={isEditing
                        ? 'externalStudent.toast.nonCycleProgramEdited'
                        : 'externalStudent.toast.nonCycleProgramCreated'}/>);
                })
                .catch(() => {
                    this.setState({ saving: false });
                    toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                });
        });
    };

    render() {
        const {
            program,
            programNameEn,
            mainFieldOfStudyEn,
            programStructureEn,
            accessRequirementsEn,
            learningOutcomesEn,
            professionalStatusEn,
            additionalInformationEn,
            sourcesOfAdditionalInformationEn,
            saving,
            loadingOptions,
            errors,
            nonCycleStudyProgramTypeOptions,
            programLeadOptions,
            attendanceTypeOptions,
            languageOptions,
        } = this.state;

        return (
            loadingOptions ? (
                <div style={{
                    paddingTop: '100px',
                    paddingBottom: '100px'
                }}>
                    <Loader active inline="centered"/>
                </div>
            ) : (
                <Segment clearing padded>
                    <Form>

                        {/* Programme Name */}
                        <Form.Group widths="equal">
                            <Form.Field required error={errors.programNameErr}>
                                <label><FormattedMessage id="externalStudent.programName"/></label>
                                <FormattedMessage id="externalStudent.enterProgramName">
                                    {msg => (
                                        <Form.Input
                                            placeholder={msg}
                                            value={program.programName || ''}
                                            onChange={(e) => this.onChangeProgram({ programName: e.target.value })}
                                            error={errors.programNameErr}
                                        />
                                    )}
                                </FormattedMessage>
                            </Form.Field>
                            <Form.Field>
                                <label><FormattedMessage id="externalStudent.programNameEn"/></label>
                                <FormattedMessage id="externalStudent.enterProgramNameEn">
                                    {msg => (
                                        <Form.Input
                                            placeholder={msg}
                                            value={programNameEn}
                                            onChange={(e) => this.setState({ programNameEn: e.target.value })}
                                        />
                                    )}
                                </FormattedMessage>
                            </Form.Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field required error={errors.nonCycleStudyProgramTypeErr}>
                                <label><FormattedMessage id="externalStudent.nonCycleStudyProgramType"/></label>
                                <Form.Dropdown
                                    search
                                    selection
                                    clearable
                                    options={nonCycleStudyProgramTypeOptions}
                                    value={program.nonCycleStudyProgramType || null}
                                    placeholder={<FormattedMessage
                                        id="externalStudent.selectNonCycleStudyProgramType"/>}
                                    onChange={(e, { value }) => this.onChangeProgram({ nonCycleStudyProgramType: value })}
                                    error={errors.nonCycleStudyProgramTypeErr}
                                />
                            </Form.Field>
                            <Form.Field>
                                <label><FormattedMessage id="externalStudent.programLead"/></label>
                                <Form.Dropdown
                                    search
                                    selection
                                    clearable
                                    options={programLeadOptions}
                                    value={program.programLeadId || null}
                                    placeholder={<FormattedMessage id="externalStudent.selectProgramLead"/>}
                                    onChange={(e, { value }) => this.onChangeProgram({ programLeadId: value })}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <label><FormattedMessage id="externalStudent.programAttendanceType"/></label>
                                <Form.Dropdown
                                    search
                                    selection
                                    clearable
                                    options={attendanceTypeOptions}
                                    value={program.attendanceType || null}
                                    placeholder={<FormattedMessage
                                        id="externalStudent.selectProgramAttendanceType"/>}
                                    onChange={(e, { value }) => this.onChangeProgram({ attendanceType: value })}
                                />
                            </Form.Field>
                            <Form.Field>
                                <label><FormattedMessage id="externalStudent.studyProgramLanguage"/></label>
                                <Form.Dropdown
                                    search
                                    selection
                                    clearable
                                    multiple
                                    options={languageOptions}
                                    value={program.languages || []}
                                    placeholder={<FormattedMessage
                                        id="externalStudent.selectStudyProgramLanguage"/>}
                                    onChange={(e, { value }) => this.onChangeProgram({ languages: value })}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <label><FormattedMessage id="externalStudent.programDurationEcts"/></label>
                                <FormattedMessage id="externalStudent.enterProgramDurationEcts">
                                    {msg => (
                                        <Form.Input
                                            type="number"
                                            placeholder={msg}
                                            value={program.maxEcts || ''}
                                            onChange={(e) => this.onChangeProgram({ maxEcts: e.target.value ? parseFloat(e.target.value) : null })}
                                        />
                                    )}
                                </FormattedMessage>
                            </Form.Field>
                            <Form.Field>
                                <label><FormattedMessage id="externalStudent.programDurationMonths"/></label>
                                <FormattedMessage id="externalStudent.enterProgramDurationMonths">
                                    {msg => (
                                        <Form.Input
                                            type="number"
                                            placeholder={msg}
                                            value={program.programDurationMonths || ''}
                                            onChange={(e) => this.onChangeProgram({ programDurationMonths: e.target.value ? parseInt(e.target.value) : null })}
                                        />
                                    )}
                                </FormattedMessage>
                            </Form.Field>
                            <Form.Field>
                                <label><FormattedMessage id="externalStudent.dateFrom"/></label>
                                <FormattedMessage id="externalStudent.enterDateFrom">
                                    {msg => (
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            time={false}
                                            placeholder={msg}
                                            value={program.dateFrom ? new Date(program.dateFrom) : null}
                                            onChange={(value) => this.onChangeProgram({ dateFrom: value })}
                                        />
                                    )}
                                </FormattedMessage>
                            </Form.Field>
                            <Form.Field>
                                <label><FormattedMessage id="externalStudent.dateTo"/></label>
                                <FormattedMessage id="externalStudent.enterDateTo">
                                    {msg => (
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            time={false}
                                            placeholder={msg}
                                            value={program.dateTo ? new Date(program.dateTo) : null}
                                            onChange={(value) => this.onChangeProgram({ dateTo: value })}
                                        />
                                    )}
                                </FormattedMessage>
                            </Form.Field>
                        </Form.Group>

                        <FormattedMessage id="externalStudent.programHasCertificateSupplement">
                            {msg => (
                                <Form.Checkbox
                                    toggle
                                    label={msg}
                                    checked={this.state.toggleCertificateSupplementInfo}
                                    onChange={(e, { checked }) => this.setState({ toggleCertificateSupplementInfo: checked })}
                                />
                            )}
                        </FormattedMessage>

                        {this.state.toggleCertificateSupplementInfo &&
                            <Segment secondary>
                                {/* Main Field of Study */}
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.mainFieldOfStudy"/></label>
                                        <FormattedMessage id="externalStudent.enterMainFieldOfStudy">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={program.mainFieldOfStudy || ''}
                                                    onChange={(e) => this.onChangeProgram({ mainFieldOfStudy: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.mainFieldOfStudyEn"/></label>
                                        <FormattedMessage id="externalStudent.enterMainFieldOfStudyEn">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={mainFieldOfStudyEn}
                                                    onChange={(e) => this.setState({ mainFieldOfStudyEn: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                </Form.Group>

                                {/* Programme Structure */}
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.programStructure"/></label>
                                        <FormattedMessage id="externalStudent.enterProgramStructure">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={program.programStructure || ''}
                                                    onChange={(e) => this.onChangeProgram({ programStructure: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.programStructureEn"/></label>
                                        <FormattedMessage id="externalStudent.enterProgramStructureEn">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={programStructureEn}
                                                    onChange={(e) => this.setState({ programStructureEn: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                </Form.Group>

                                {/* Access Requirements */}
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.accessRequirements"/></label>
                                        <FormattedMessage id="externalStudent.enterAccessRequirements">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={program.accessRequirements || ''}
                                                    onChange={(e) => this.onChangeProgram({ accessRequirements: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.accessRequirementsEn"/></label>
                                        <FormattedMessage id="externalStudent.enterAccessRequirementsEn">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={accessRequirementsEn}
                                                    onChange={(e) => this.setState({ accessRequirementsEn: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                </Form.Group>

                                {/* Learning Outcomes */}
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.learningOutcomes"/></label>
                                        <FormattedMessage id="externalStudent.enterLearningOutcomes">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={program.learningOutcomes || ''}
                                                    onChange={(e) => this.onChangeProgram({ learningOutcomes: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.learningOutcomesEn"/></label>
                                        <FormattedMessage id="externalStudent.enterLearningOutcomesEn">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={learningOutcomesEn}
                                                    onChange={(e) => this.setState({ learningOutcomesEn: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                </Form.Group>

                                {/* Professional Status */}
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.professionalStatus"/></label>
                                        <FormattedMessage id="externalStudent.enterProfessionalStatus">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={program.professionalStatus || ''}
                                                    onChange={(e) => this.onChangeProgram({ professionalStatus: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.professionalStatusEn"/></label>
                                        <FormattedMessage id="externalStudent.enterProfessionalStatusEn">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={professionalStatusEn}
                                                    onChange={(e) => this.setState({ professionalStatusEn: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                </Form.Group>

                                {/* Additional Information */}
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label><FormattedMessage
                                            id="externalStudent.additionalInformation"/></label>
                                        <FormattedMessage id="externalStudent.enterAdditionalInformation">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={program.additionalInformation || ''}
                                                    onChange={(e) => this.onChangeProgram({ additionalInformation: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field>
                                        <label><FormattedMessage
                                            id="externalStudent.additionalInformationEn"/></label>
                                        <FormattedMessage id="externalStudent.enterAdditionalInformationEn">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={additionalInformationEn}
                                                    onChange={(e) => this.setState({ additionalInformationEn: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                </Form.Group>

                                {/* Sources of Additional Information */}
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label><FormattedMessage
                                            id="externalStudent.sourcesOfAdditionalInformation"/></label>
                                        <FormattedMessage id="externalStudent.enterSourcesOfAdditionalInformation">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={program.sourcesOfAdditionalInformation || ''}
                                                    onChange={(e) => this.onChangeProgram({ sourcesOfAdditionalInformation: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field>
                                        <label><FormattedMessage
                                            id="externalStudent.sourcesOfAdditionalInformationEn"/></label>
                                        <FormattedMessage
                                            id="externalStudent.enterSourcesOfAdditionalInformationEn">
                                            {msg => (
                                                <Form.TextArea
                                                    placeholder={msg}
                                                    value={sourcesOfAdditionalInformationEn}
                                                    onChange={(e) => this.setState({ sourcesOfAdditionalInformationEn: e.target.value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                </Form.Group>
                            </Segment>
                        }

                        {/* Comment */}
                        <Form.Field>
                            <label><FormattedMessage id="externalStudent.comment"/></label>
                            <FormattedMessage id="externalStudent.enterComment">
                                {msg => (
                                    <Form.TextArea
                                        placeholder={msg}
                                        value={program.comment || ''}
                                        onChange={(e) => this.onChangeProgram({ comment: e.target.value })}
                                    />
                                )}
                            </FormattedMessage>
                        </Form.Field>

                        <Button floated="right" basic color="blue" disabled={saving}
                                onClick={this.props.onCloseForm}>
                            <FormattedMessage id="externalStudent.cancel"/>
                        </Button>
                        <Button floated="right" color="blue" loading={saving} onClick={this.handleSubmit}>
                            <FormattedMessage id="externalStudent.confirm"/>
                        </Button>
                    </Form>
                </Segment>
            )
        );
    }
}

export default NonCycleProgramForm;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleProgram/NonCycleProgramForm.js